/**
 * Utilities for live color picker cursor
 */

/**
 * Generate a color picker cursor SVG with the sampled color in the inner sample area.
 * The eyedropper body stays black, only the inner oval/diamond shows the hovered color.
 */
export function generateColorPickerCursor(hexColor: string): string {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path fill="#000000" d="M20.71 5.63l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-3.12 3.12-1.93-1.91-1.41 1.41 1.42 1.42L3 16.25V21h4.75l8.92-8.92 1.42 1.42 1.41-1.41-1.92-1.92 3.12-3.12c.4-.4.4-1.03.01-1.42z"/>
    <path fill="${hexColor}" stroke="#000000" stroke-width="1" d="M6.92 19L5 17.08l8.06-8.06 1.92 1.92L6.92 19z"/>
  </svg>`;

  const cleanSvg = svg.replace(/\n\s*/g, '');
  const encoded = encodeURIComponent(cleanSvg).replace(/'/g, '%27').replace(/"/g, '%22');

  return `url("data:image/svg+xml,${encoded}") 4 20, auto`;
}
